// extracted by mini-css-extract-plugin
module.exports = {"ufb-logo":"ufb-section_ufb-logo__VGY90","cta":"ufb-section_cta__AR8_O"};